// src/config/api.js
// Single source of truth for backend API URL

const API_BASE_URL =
 // 'http://localhost:8080';   // 🔧 LOCAL (use only during dev)
 'https://joyaura-backend.onrender.com'; // 🚀 PROD
``
export { API_BASE_URL };
export default API_BASE_URL;
